<!-- <mat-card-header>
  <mat-card-title>Welcome to Your Private Space !!!</mat-card-title>
</mat-card-header>
<mat-card-content> </mat-card-content> -->
<div class="text-center mat-header">
  Dashboard
</div>
<div class="row d-flex justify-content-center" *ngIf="isLoading">
  <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
</div>
<mat-card-content *ngIf="!isLoading">
  <div class="top-section">
    <div class="widget-container">
      <div class="widget green pointer" [routerLink]="['/private-space/view-properties']">
        <div class="value row">
          <div class="col-sm-4">
            <mat-icon style="font-size: 80px !important;">widgets</mat-icon>
          </div>
          <div class="col-sm-4 offset-sm-4">
            <div class="top">{{ propertiesNumber }}</div>
            <div class="bottom">Properties</div>
          </div>
        </div>
      </div>
      <div class="widget yellow pointer" [routerLink]="['/private-space/view-sporsorship-requests']">
        <div class="value row" style="margin-left: 17px !important;">
          <div class="col-sm-4">
            <mat-icon style="font-size: 80px !important;">assignment</mat-icon>
          </div>
          <div class="col-sm-4 offset-sm-4">
            <div class="top">{{ sponsorshipRequestsNumber }}</div>
            <div class="bottom" style="width: 125px;">Sponsorship Requests</div>
          </div>
        </div>
      </div>
      <div class="widget red pointer" [routerLink]="['/private-space/view-valuation-requests']">
        <div class="value row"  style="margin-left: 30px !important;">
          <div class="col-sm-4">
            <mat-icon style="font-size: 80px !important;">money</mat-icon>
          </div>
          <div class="col-sm-4 offset-sm-4">
            <div class="top">{{ valRequestsNumber }}</div>
            <div class="bottom" style="width: 113px;">Valuation Requests</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>

</mat-card-content>


